










import { Component, Vue, Prop } from 'vue-property-decorator';
import { Profile } from 'client-website-ts-library/types/Profile';
import { API } from 'client-website-ts-library/services';

import ProfileCard from './ProfileCard.vue';

@Component({
  components: {
    ProfileCard,
  },
})
export default class OwnerCards extends Vue {
  private andrianaProfile: Profile | null = null;

  private dominikProfile: Profile | null = null;

  mounted(): void {
    API.Profiles.Get('3b8b5079-0b5c-4e8a-bf7c-26dec3857036').then((profile) => {
      this.andrianaProfile = profile;
    });

    API.Profiles.Get('2b0454ab-71fd-4876-baca-f23ee025a501').then((profile) => {
      this.dominikProfile = profile;
    });
  }
}
